<template>
  <div>
    <b-row>
      <b-col>
        <toggle-single id="enable-agenda"
                       label-name="Enabled"
                       :toggle-model="hasCompanyInfo"
                       @toggle-click="handleToggleClick"
        />
      </b-col>
      <b-col>
        <b-link
            class="float-right"
          @click="handleResetClick">
        Reset
        </b-link>
      </b-col>
    </b-row>

    <!--LOGO -->
    <div style="text-align: center; margin-bottom: 15px">
      <b-img
          v-if="companyImgURL"
          v-bind="mainProps"
          thumbnail
          fluid
          :src="companyImgURL"
          :alt="`${companyName} logo`"
      />
    </div>
    <!-- NAME -->
    <b-form-group>
      <label-info
          id="session-companyName"
          label-name="Company Name"
          label-info=""
          :is-required="true"
      />
      <b-form-input
          type="text"
          required
          v-model="companyName"
          @input="handleValueChange('companyName', companyName)"
          placeholder="My Session"
      />
    </b-form-group>

    <!-- PHONE -->
    <b-form-group>
      <label-info
          id="session-contactPhone"
          label-name="Contact Phone"
          label-info=""
          :is-required="false"
      />
      <b-form-input
          type="text"
          v-model="companyPhone"
          @input="handleValueChange('companyPhone', companyPhone)"
          placeholder="()"
      />
    </b-form-group>

    <!-- EMAIL -->
    <b-form-group>
      <label-info
          id="session-companyEmail"
          label-name="Company Email"
          label-info=""
          :is-required="false"
      />
      <b-form-input
          type="text"
          required
          v-model="companyEmail"
          @input="handleValueChange('companyEmail', companyEmail)"
          placeholder="@"
      />
    </b-form-group>

    <!--- DESCRIPTION  -->
    <b-form-group>
      <label-info
          id="session-companyBio"
          label-name="Bio"
          label-info=""
          :is-required="true"
      />
      <transition name="fadeHeight" mode="out-in">
        <Editor
            id="textarea-default"
            v-show="true"
            @input="input"
            :clear="clear"
            :content="companyBio"
            @resetClear="resetClear"
        />
      </transition>
    </b-form-group>
    <pre v-if="!production" class="small">{{ context }}</pre>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
import ToggleSingle from "@/components/common/toggleSingle";
export default {
  name: "AddEditSession_CompanyInfo",
  components: {
    LabelInfo,
    Editor,
    ToggleSingle
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
    companyName() {
      return this.form && this.form.companyName ? this.form.companyName : null;
    },
    companyEmail(){
      return this.form && this.form.companyEmail ? this.form.companyEmail : null;
    },
    companyPhone(){
      return this.form && this.form.companyPhone? this.form.companyPhone : null;
    },
    companyExpertise(){
      return this.form && this.form.companyExpertise ? this.form.companyExpertise : null;
    },
    companyBio(){
      return this.form && this.form.companyBio ? this.form.companyBio : null;
    },
    companyImgURL(){
      return this.form && this.form.companyImgURL ? this.form.companyImgURL : null;
    }
  },
  methods: {
    handleToggleClick(){
      this.hasCompanyInfo = !this.hasCompanyInfo;
      this.handleValueChange('hasCompanyInfo', this.hasCompanyInfo);
    },
    handleResetClick(){
      this.$emit('reset-click');
    },
    handleValueChange(key,value) { //mixin
      this.$emit('value-change', {key:key, value:value});
      this.$forceUpdate();
    },
    input(val) {
      this.$emit('value-change', {key:'companyBio', value:val.content});
    },
    resetClear() {
      this.clear = false;
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleCalendarDateSelected(date){
      this.$emit('value-change', {key:'session_date_at', value: date});
    },
    handleCalendarFocusClick(isFocused){
      this.calendar = isFocused;
    }
  },
  data() {
    return {
      hasCompanyInfo: this.form && this.form.hasCompanyInfo ? this.form.hasCompanyInfo : false,
      production: true,
      mainProps: { blank: false, blankColor: '#777', width: 150, height: 150, class: 'm1' },
      clear: false,
      calendar: false,
      context: null
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

